import { Controller } from "@hotwired/stimulus"

// Schickt die Werte des umgebenden Formulars an eine andere Adresse, z. B.
// „Filter speichern“ aus dem GET-Filterformular der Tätigkeiten. Dafür baut der
// Controller ein verborgenes Hilfsformular (POST, optional _method, CSRF-Token
// aus dem Layout) und lässt das Original unverändert. So landet das Token nie
// in der Adresse eines GET-Filters, und der Turbo-Cache behält das Original.
// Ersetzt saveFilter/updateFilter aus admin/tasks.js.erb.
export default class extends Controller {
  static values = { url: String, method: String }

  submit(event) {
    event?.preventDefault()
    const source = this.element.form
    const form = document.createElement("form")
    form.hidden = true
    form.setAttribute("action", this.urlValue)
    form.setAttribute("method", "post")

    for (const [name, value] of this.entries(source)) form.append(this.hiddenField(name, value))
    if (this.hasMethodValue && this.methodValue.toLowerCase() !== "post") {
      form.append(this.hiddenField("_method", this.methodValue))
    }
    const param = this.meta("csrf-param")
    const token = this.meta("csrf-token")
    if (param && token) form.append(this.hiddenField(param, token))

    form.addEventListener("turbo:submit-end", () => form.remove(), { once: true })
    document.body.append(form)
    form.requestSubmit()
  }

  // Erfolgreiche Felder wie beim normalen Absenden: ohne gesperrte, ohne
  // Buttons, Checkboxen/Radios nur angekreuzt, Mehrfachauswahl je Option.
  // (Nicht FormData, weil die Test-Umgebung happy-dom gesperrte Felder mitnimmt.)
  entries(source) {
    const entries = []
    for (const field of source.elements) {
      if (!field.name || field.disabled || field.closest("fieldset[disabled]")) continue
      if (["button", "submit", "reset", "image", "file"].includes(field.type)) continue
      if (["checkbox", "radio"].includes(field.type) && !field.checked) continue
      if (field.tagName === "SELECT") {
        for (const option of field.options) if (option.selected) entries.push([field.name, option.value])
      } else {
        entries.push([field.name, field.value])
      }
    }
    return entries
  }

  hiddenField(name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    return input
  }

  meta(name) {
    return document.querySelector(`meta[name="${name}"]`)?.content
  }
}
